import { cn } from '@crm/ui';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  /** O icone da propria entidade - o mesmo que titula a tela. */
  icon?: React.ReactNode;
  /** Uma linha, sem explicacao: a tela vazia nao e hora de ensinar. */
  title: string;
  className?: string;
}

/**
 * Lista sem registro. Ganha corpo - icone em circulo e uma linha em peso de
 * texto normal - porque a frase cinza e miuda no meio do cartao se lia como
 * falha de carregamento. Nada de vermelho: vazio nao e erro.
 */
export function EmptyState({ icon, title, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-4 py-14 text-center',
        className,
      )}
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-muted text-muted-foreground [&_svg]:h-7 [&_svg]:w-7">
        {icon ?? <Inbox />}
      </span>
      <p className="text-base font-medium text-foreground">{title}</p>
    </div>
  );
}
